import React from 'react';
import { Icon, Tooltip } from '@wegroup/design-system';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import { H4 } from 'wg-fe-ui';
import RadioCheck from './RadioCheck';

// Types
import { VersionsProps } from './VehicleLookupOrderTable';
import { mq } from '../utils/styledComponentsUtils';

interface Props extends VersionsProps {
  isSelected: boolean;
  onSelected: (arg0: string) => void;
}

const VehicleMobileItem: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  version,
  brand,
  model,
  kw,
  cc,
  modelYear,
  co2,
  price,
  isSelected,
  onSelected,
}) => {
  const { t } = useTranslation();
  return (
    <Wrapper onClick={() => onSelected(id)} isSelected={isSelected}>
      <Header>
        <StyledH4>
          {brand?.toUpperCase()} {model} {version}
        </StyledH4>
        <RadioCheck isSelected={isSelected} />
      </Header>
      <Body>
        <div>
          <InfoTitle>
            {t('kw')}
            <Tooltip label={t('KW-INFO')} shouldWrapChildren>
              <Icon name="GeneralStatusInfo" />
            </Tooltip>
          </InfoTitle>
          <InfoText>
            {kw} {t('kW')}
          </InfoText>
        </div>
        <div>
          <InfoTitle>{t('CC')}</InfoTitle>
          <InfoText>{cc}</InfoText>
        </div>
        <div>
          <InfoTitle>{t('CO2')}</InfoTitle>
          <InfoText>{co2}</InfoText>
        </div>
        <div>
          <InfoTitle>{t('Year')}</InfoTitle>
          <InfoText>{modelYear}</InfoText>
        </div>
        <div>
          <InfoTitle>{t('Price')}</InfoTitle>
          <InfoText>
            {price
              ? price.toLocaleString('nl-BE', {
                  style: 'currency',
                  currency: 'EUR',
                })
              : '-'}
          </InfoText>
        </div>
      </Body>
    </Wrapper>
  );
};

const StyledH4 = styled(H4)`
  font-size: 1.8rem;
  line-height: 125%;
`;

const InfoText = styled.p`
  line-height: 125%;
`;

const InfoTitle = styled.p`
  color: #8990a3;
  line-height: 125%;
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8rem;
  margin-top: 1.6rem;

  ${mq.mobileL} {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Wrapper = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  padding: ${({ isSelected }) =>
    isSelected ? 'calc(1.6rem - 1px)' : '1.6rem'};
  border-radius: 4px;
  border: ${({ isSelected }) => (isSelected ? '2px' : '1px')} solid
    ${({ theme, isSelected }) => (isSelected ? theme.primary[500] : '#e4e4e4')};
`;

export default VehicleMobileItem;
